import { useMutation } from '@tanstack/react-query'
import { useApiClientUser } from '~/@api/client/useApiClientUser'
import type { ISetSecuritySettingsRequest } from '~/@api/generated-api-types-user/Api'
import { getApiErrorMessage } from '~/@lib/utils/error.utils'

function useSecuritySettings() {
  const client = useApiClientUser()

  const {
    mutate: setSecuritySettings,
    isPending: isSettingSecuritySettings,
    error,
  } = useMutation({
    mutationFn: async (props: ISetSecuritySettingsRequest) => {
      return await client.user
        .settingsControllerSetSecuritySettings(props, { secure: true })
        .then((res) => res.data)
    },
  })

  return {
    setSecuritySettings,
    isSettingSecuritySettings,
    error: getApiErrorMessage(
      error,
      'Nastavenia zabezpečenia sa nepodarilo uložiť.'
    ),
  }
}

export { useSecuritySettings }
